// Payout destinations partners can choose for cross-chain fees. These must
// match the backend's allowlist (internal/handlers/cross_chain.go).
export type PayoutOption = {
  chain: string;
  asset: string;
  label: string;
  placeholder: string;
};

export const PAYOUT_OPTIONS: PayoutOption[] = [
  { chain: 'solana', asset: 'USDC', label: 'USDC on Solana', placeholder: 'Solana address' },
  { chain: 'spark', asset: 'USDB', label: 'USDB on Spark', placeholder: 'spark1…' },
];

export const payoutOptionKey = (chain: string, asset: string) => `${chain}:${asset}`;

export const findPayoutOption = (key: string): PayoutOption | undefined =>
  PAYOUT_OPTIONS.find((o) => payoutOptionKey(o.chain, o.asset) === key);
